export const DEFAULT_SEARCH_ICON_CLASS = 'ddc-icon-search';

/**
 * Normalizes the free-text searchButtonIcon pref into a single ddc-icon-* class.
 * Tolerates surrounding whitespace, uppercase and a pasted ddc-icon- prefix.
 * Anything that isn't lowercase letters, digits and hyphens after that falls
 * back to the default search icon. Names are not checked against the icon
 * font, so an unknown name like "foo" still yields ddc-icon-foo.
 *
 * @param { string? } searchButtonIcon
 * @returns { string }
 */
export const getSearchIconClass = (searchButtonIcon) => {
	const iconName = (searchButtonIcon ?? '')
		.trim()
		.toLowerCase()
		.replace(/^ddc-icon-/, '');

	return /^[a-z0-9-]+$/.test(iconName)
		? `ddc-icon-${iconName}`
		: DEFAULT_SEARCH_ICON_CLASS;
};
